import React, { useEffect, useState } from 'react';
import { Shield, Zap, Mail, Heart } from 'lucide-react';
import { trackAddToCart } from '../hooks/useMetaPixel';
export function ProductHero() {
  const [viewers, setViewers] = useState(100);
  useEffect(() => {
    const startViewerCount = () => {
      let count = Math.floor(Math.random() * (120 - 80 + 1) + 80);
      setViewers(count);
      const interval = setInterval(() => {
        let increment = Math.floor(Math.random() * 3) - 1;
        count += increment;
        if (count < 60) count = 60;
        setViewers(count);
      }, 4500);
      return interval;
    };
    const interval = startViewerCount();
    return () => clearInterval(interval);
  }, []);
  return <section className="py-[40px] px-0 bg-[#F8F6FF]" data-id="element-217">
      <div className="container max-w-[500px] mx-auto px-[15px]" data-id="element-218">
        {/* Product Image */}
        <div className="mx-auto my-[20px] overflow-hidden shadow-[0_15px_30px_rgba(124,58,237,0.15)] rounded-[12px] max-w-full" data-id="element-219">
          <img src="https://cdn.magicpatterns.com/uploads/4Cy5CY3dQRaomrgLfoCR7g/1apoyo.png" alt="El Apoyo Incondicional — Guía Práctica para Familiares" className="w-full block" data-id="element-220" />
        </div>

        <div className="text-center mx-auto my-[25px] mb-[15px]" data-id="element-221">
          <p className="text-[11px] font-[600] text-[#7C3AED] uppercase tracking-wider bg-[#F3E8FF] inline-block px-3 py-1 rounded-full mb-2" data-id="element-222">
            +1.200 FAMILIAS AYUDADAS
          </p>
          <h1 className="text-[22px] leading-[1.4] font-[700] text-[#1A1035] font-['Montserrat']" data-id="element-223">
            📦 El Apoyo Incondicional
          </h1>
          <p className="text-[#6B7280] text-[14px] mt-1" data-id="element-224">
            La guía práctica para el familiar más cercano
          </p>
        </div>

        <div className="bg-white rounded-[12px] p-[20px] mx-auto my-[20px] border border-[#E5E7EB] shadow-sm max-w-full relative overflow-hidden" data-id="element-225">
          <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-[#7C3AED] to-[#D4A017]" data-id="element-226"></div>
          <div className="flex flex-col items-center gap-[3px]" data-id="element-227">
            <div className="text-[16px] line-through text-[#9CA3AF]" data-id="element-228">$37</div>
            <div className="text-[42px] text-[#7C3AED] font-[800] leading-none" data-id="element-229">
              $7.77 <span className="text-[16px] text-[#6B7280]" data-id="element-230">USD</span>
            </div>
            <div className="bg-[#D4A017] text-white px-[14px] py-[4px] rounded-[50px] font-bold text-[12px] uppercase mt-[10px] shadow-sm" data-id="element-231">
              AHORRO 79%
            </div>
          </div>
          <div className="flex justify-around mt-[20px] pt-[15px] border-t border-gray-100 text-[#6B7280] text-[12px]" data-id="element-232">
            <div className="flex items-center gap-1.5" data-id="element-233">
              <Shield className="w-3.5 h-3.5 text-[#059669]" data-id="element-234" /> Pago Seguro
            </div>
            <div className="flex items-center gap-1.5" data-id="element-235">
              <Zap className="w-3.5 h-3.5 text-[#D4A017]" data-id="element-236" /> Acceso Instantáneo
            </div>
          </div>
        </div>

        <div className="max-w-[500px] mx-auto my-[25px] mb-[10px] flex flex-col gap-[12px]" data-id="element-237">
          <div className="bg-[#1A1035] text-white font-[700] p-[12px] rounded-[8px] text-[15px] text-center shadow-md" data-id="element-238">
            <strong data-id="element-239">
              <span className="viewer-count text-[#A78BFA]" data-id="element-240">{viewers}</span>{' '}
              personas
            </strong>{' '}
            están viendo esta oferta
          </div>
          <div className="bg-[#DC2626] text-white font-[700] p-[12px] rounded-[8px] text-[15px] text-center flex items-center justify-center gap-[10px] shadow-md animate-pulse" data-id="element-241">
            <span className="w-[10px] h-[10px] bg-white rounded-full" data-id="element-242"></span>{' '}
            ¡Últimos <strong data-id="element-243">5 Cupos</strong> en Oferta!
          </div>
        </div>

        <a className="block w-full bg-gradient-to-br from-[#7C3AED] to-[#6D28D9] text-white border-none p-[16px] text-[18px] font-[700] rounded-[50px] cursor-pointer shadow-[0_8px_20px_rgba(124,58,237,0.3)] text-center no-underline uppercase font-['Montserrat'] animate-pulse-custom hover:transform hover:-translate-y-[3px] hover:scale-[1.02] hover:shadow-[0_12px_25px_rgba(124,58,237,0.5)] transition-all duration-400" href="https://nutrikaia.com/cart/46420389494974:1" onClick={() => trackAddToCart()} data-id="element-244">
          ¡DESCARGAR AHORA MISMO!
        </a>

        <div className="flex items-center justify-center gap-[12px] bg-white rounded-[8px] p-[12px] mx-auto my-[15px] shadow-[0_2px_8px_rgba(0,0,0,0.05)] max-w-full border border-gray-100" data-id="element-245">
          <div className="text-[24px] text-[#7C3AED]" data-id="element-246">
            <Mail data-id="element-247" />
          </div>
          <div data-id="element-248">
            <h3 className="text-[14px] color-[#1F2937] font-[700] font-['Montserrat']" data-id="element-249">
              Acceso inmediato
            </h3>
            <p className="text-[12px] text-[#6B7280]" data-id="element-250">
              Te llega directo a tu correo electrónico
            </p>
          </div>
        </div>
      </div>
    </section>;
}